export class SelectConfig {
    [x: string]: any;
    /**
     * 组件对象，用于区分组件类型
     */
    ui?: {
        type: 'select',
        data?: Array<any>,
        mode?: string,
        modelChange?: (value) => void
    };
    /**
     * 下拉对应的key
     */
    name?: string;
    /**
     * 当前组件与name为**的组件产生了父子关系，联动查询时会用上
     */
    parent?: string;
    /**
     * 当前组件与name为**的组件产生了父子关系，联动查询时会用上
     */
    children?: string;
    /**
     * 当前组件与name为**的组件产生了父子关系时，key作为子级选项的请求参数之一，联动查询时会用上
     */
    key?: string;
    /**
     * 下拉对应的文字
     */
    value?: any;
    /**
     * 下拉选中项对象， 默认为null
     */
    selectedValue?: any;
    /**
     * 获取下拉数据的请求地址
     */
    url?: string;
    /**
     * 获取下拉数据的请求参数
     */
    params?: object;
    /**
     * 下拉框提示信息
     */
    placeHolder?: string;
    /**
     * 下拉框对应的label
     */
    label?: string;
    /**
     * 下拉是否被禁用，默认为false
     */
    disabled?: boolean;
    /**
     * 下拉是否显示清除图标，默认为true
     */
    allowClear?: boolean;
    /**
     * 下拉是否支持前端搜索，默认为true
     */
    showSearch?: boolean;
    /**
     * 下拉类型  default,tags,multiple， 默认为default
     */
    mode?: string;
    /**
     * 下拉数据
     */
    data?: any[];
    /**
     * 下拉框宽度  默认为180px
     */
    width?: string;
    /**
     * 是否默认加载数据,默认为false
     */
    defaultLoad?: boolean;
    /**
     * 是否默认选中第一条数据，默认为false
     */
    isSelectedFirst?: boolean;
    /**
     * 是否分页，默认为false
     */
    isPage?: boolean;
    /**
     * 每页显示条数，默认为20
     */
    pageSize?: number;
    /**
     * 当前页码，默认为1
     */
    page?: number;
    /**
     * 自定义事件
     */
    modelChange?: (e) => {};
    constructor() {
       this.url = '';
       this.selectedValue = null;
       this.data = [];
       this.ui.data = [];
       this.isPage = false;
       this.page = 1;
       this.pageSize = 10;
       this.isSelectedFirst = false;
       this.defaultLoad = true;
       this.mode = 'default';
       this.allowClear = true;
       this.params = {};
    }
}
